module.exports = __webpack_public_path__ + "static/media/pc3.600e3054.JPG";